/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.user.progress.rpc.UserProgressReaderChirpService
 */
import * as References from './UserProgressReaderChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.user.progress.rpc.UserProgressReaderChirpService#getAllUserProgress
 */
export const GET_ALL_USER_PROGRESS_QUERY_FIELD_NAME = 'com_hubspot_academy_user_progress_rpc_UserProgressReaderChirpService_getAllUserProgress';
export const GET_ALL_USER_PROGRESS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALL_USER_PROGRESS_QUERY_FIELD_NAME,
  args: ['includeNonIndividualProgressContext', 'contentTypeFilter'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getAllUserProgressRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.user.progress.rpc.UserProgressReaderChirpService#getPlaylistProgress
 */
export const GET_PLAYLIST_PROGRESS_QUERY_FIELD_NAME = 'com_hubspot_academy_user_progress_rpc_UserProgressReaderChirpService_getPlaylistProgress';
export const GET_PLAYLIST_PROGRESS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PLAYLIST_PROGRESS_QUERY_FIELD_NAME,
  args: ['playlistId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getPlaylistProgressRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.user.progress.rpc.UserProgressReaderChirpService#getPlaylistProgressForUsers
 */
export const GET_PLAYLIST_PROGRESS_FOR_USERS_QUERY_FIELD_NAME = 'com_hubspot_academy_user_progress_rpc_UserProgressReaderChirpService_getPlaylistProgressForUsers';
export const GET_PLAYLIST_PROGRESS_FOR_USERS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PLAYLIST_PROGRESS_FOR_USERS_QUERY_FIELD_NAME,
  args: ['playlistId', 'userIds'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getPlaylistProgressForUsersRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});